import useTranslation from 'hooks/useTranslation'
import React from 'react'
import './style.scss'

interface ErrorProps {
  text?: string
  staticPos?: boolean
}

const Error: React.FC<ErrorProps> = ({ text, staticPos = false }) => {
  const { t } = useTranslation('basic')
  return (
    <div className={`error --${staticPos ? 'static' : 'centered'}`}>
      {text || t('errorMessage')}
    </div>
  )
}

export default Error